/**
 * Normalize notification action URLs to in-app React Router paths.
 * Absolute portal URLs (from emails/legacy rows) become pathname + search.
 */
export function toAppPath(url) {
  if (!url) return null;
  const raw = String(url).trim();
  try {
    if (/^https?:\/\//i.test(raw)) {
      const u = new URL(raw);
      return `${u.pathname}${u.search}${u.hash}`;
    }
  } catch {
    /* keep raw */
  }
  return raw.startsWith('/') ? raw : `/${raw}`;
}
